/**
* @Description: IPHONE_PAY_COURSE
* @author XuZiYu
* @date 2021-12-11 17:41
*/
<template>
  <div class="wrapper-iphone-pay-course">
    <div class="header">
      <div class="header-left" @click="goBack"><img src="@/assets/vip/icon_back1.png" alt=""/></div>
      <div class="header-main">iPhone支付教程</div>
      <div class="header-right"></div>
    </div>

    <div class="reset-buy">
      <img src="@/assets/vipV3/icon_hfgm.png" alt="">
      <span class="btn" @click="resetBuy"></span>
    </div>
    <div class="custom-tab">
      <div v-for="(item, index) in tabItems" :key="index" class="custom-tab-item" :class="{active: index === tabIndex}" @click="handleToggle(index)"><span>{{item}}</span></div>
    </div>

    <div class="img-wrap" ref="img">
      <img v-if="tabIndex === 0" class="img" src="@/assets/vip/picture_wxzxjc.png" alt="">
      <img v-if="tabIndex === 1" class="img" src="@/assets/vip/picture_zfbzxjc.png" alt="">
    </div>
  </div>

</template>

<script>
export default {
    name: 'iphonePayCourse',
    data () {
        return {
            tabItems: ['微信支付', '支付宝支付'],
            tabIndex: 0
        }
    },
    methods: {
        // 返回
        goBack () {
            this.$parent.iphonePayCourseVisible = false
        },
        handleToggle (index) {
            this.tabIndex = index

            this.$refs.img.scrollTop = 0
        },
        resetBuy () {
            this.$parent.submit()
        }
    },
    created () {}
}
</script>

<style scoped lang="scss">

  .wrapper-iphone-pay-course{
    position: fixed;
    background: #fff;
    z-index: 3;
    top: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    .img-wrap{
      flex: 1;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
    }
    .img-wrap .img{
      width: 100%;
    }
    .custom-tab{
      display: flex;
      align-items: center;
      height: 55px;
    }
    .custom-tab-item{
      flex: 1;
      font-size: 13px;
      text-align: center;
    }
    .custom-tab-item span{
      position: relative;
    }
    .custom-tab-item.active{
      font-size: 15px;
      color: #53CB85;
      font-weight: 600;
    }
    .custom-tab-item.active span::after{
      content: '';
      position: absolute;
      top:100%;
      left:0;
      width: 100%;
      height: 3px;
      background-color: #53CB85;
      border-radius: 2px;
      transform: translateY(8px);
    }

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 60px;
      background: #ffffff;

      .header-main {
        font-size: 18px;

        font-weight: bold;
        color: #333333;
      }

      .header-left, .header-right {
        width: 50px;
        display: flex;
        padding: 15px 10px;
        font-size: 0;
        line-height: 1;

        img {
          width: 24px;
          height: 24px;
        }
      }
    }
    .reset-buy{
      position: relative;
      img{
        width: 375px;
      }
      .btn{
        position: absolute;
        right: 5px;
        top: 10px;
        width: 100px;
        height: 35px;
      }
    }
  }
</style>
